import client from "./axiosConfig";

export const getProjectMessages = (pid,params) =>
{
    const config = {
        url: `/projects/${pid}/project-conversation/`,
        method: "GET",
        params
    }
    const result = client(config);
    return result;
}

export const sendMessages = (pid,data) =>
{
    const config = {
        url: `/projects/${pid}/project-conversation/`,
        method: "POST",
        data
    }
    const result = client(config);
    return result;
}